/**
 * AuditIcons.jsx — Minimal icon + badge system for Audit module
 */

/* ── Icon wrapper ── */
const Wrap = ({ size, children }) => (
  <span style={{
    display: "inline-flex", alignItems: "center", justifyContent: "center",
    width: size, height: size, minWidth: size, minHeight: size,
    flexShrink: 0, lineHeight: 1, verticalAlign: "middle",
  }}>
    {children}
  </span>
);

export const AuditIcon = ({ name, size = 14, color = "currentColor" }) => {
  const s = Number(size);
  const base = {
    width: s, height: s, viewBox: "0 0 24 24", fill: "none",
    stroke: color, strokeWidth: 2, strokeLinecap: "round",
    strokeLinejoin: "round", style: { display: "block", flexShrink: 0 },
  };

  const icons = {
    location: (
      <svg {...base}>
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
        <circle cx="12" cy="9" r="2.5"/>
      </svg>
    ),
    search: (
      <svg {...base}><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
    ),
    chevron: (
      <svg {...base}><path d="M6 9l6 6 6-6"/></svg>
    ),
    check: (
      <svg {...base}><polyline points="20 6 9 17 4 12"/></svg>
    ),
    x: (
      <svg {...base}><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
    ),
    filter: (
      <svg {...base}><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
    ),
    refresh: (
      <svg {...base}>
        <polyline points="23 4 23 10 17 10"/>
        <polyline points="1 20 1 14 7 14"/>
        <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
      </svg>
    ),
    "more-horizontal": (
      <svg {...base}>
        <circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/>
      </svg>
    ),
    "arrow-left": (
      <svg {...base}><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
    ),
    user: (
      <svg {...base}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
    ),
    "check-circle": (
      <svg {...base}><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
    ),
  };

  return <Wrap size={s}>{icons[name] || <svg {...base}/>}</Wrap>;
};

/* ── Highlight text ── */
export const HighlightText = ({ text = "", query = "" }) => {
  if (!query || !text) return <>{text}</>;
  const idx = text.toLowerCase().indexOf(query.toLowerCase());
  if (idx === -1) return <>{text}</>;
  return (
    <>
      {text.slice(0, idx)}
      <mark style={{ background: "#fef08a", color: "inherit", borderRadius: 2, padding: "0 1px" }}>
        {text.slice(idx, idx + query.length)}
      </mark>
      {text.slice(idx + query.length)}
    </>
  );
};

/* ── StatusBadge ── */
const STATUS_MAP = {
  PENDING:   { label: "Pending",   cls: "audit-badge-pending",  dot: "#d97706" },
  IN_REVIEW: { label: "In Review", cls: "audit-badge-review",   dot: "#2563eb" },
  APPROVED:  { label: "Approved",  cls: "audit-badge-approved", dot: "#16a34a" },
  ACCEPTED:  { label: "Accepted",  cls: "audit-badge-approved", dot: "#16a34a" },
  REJECTED:  { label: "Rejected",  cls: "audit-badge-rejected", dot: "#dc2626" },
};

export const StatusBadge = ({ status }) => {
  const s = STATUS_MAP[(status || "PENDING").toUpperCase()] || { label: status || "—", cls: "audit-badge-pending", dot: "#9ca3af" };
  return (
    <span className={`audit-badge ${s.cls}`}>
      <span className="audit-badge-dot" style={{ background: s.dot }} />
      {s.label}
    </span>
  );
};
